<template>
  <div>
  <loading :active="!pageLoaded" :is-full-page="false" />
  <div v-if="pageLoaded">
    <!-- Chatter Status Table -->
    <chatter-status-table :projectId="filter.projectId" :assignee="filter.assignee"
      @click:subStatusBadge="clickSubStatusBadgeHandler" :isRefreshed="refresh" />
    <!-- /Chatter Status Table -->

    <!-- Today Work -->
    <!--
    <b-card class="today-work-wrap">
      <div class="work-wrap">
        <div class="work-progress">
          <div class="title-wrap">
            <div class="title">Today’s Work</div>
            <div class="rate">
              <span>5H&nbsp;</span>
              <span>(50%)</span>
            </div>
          </div>
          <div class="progress-bar">
            <div class="bar" style="width: 50%;"></div>
          </div>
        </div>
        <ul class="status-list-wrap">
          <li class="status-list">
            <button type="button" class="status-item">
              <span class="status">To Do</span>
              <span class="num">01</span>
            </button>
          </li>
          <li class="status-list bg-gray">
            <button type="button" class="status-item">
              <span class="status">In Progress</span>
              <span class="num">03</span>
            </button>
          </li>
          <li class="status-list bg-gray">
            <button type="button" class="status-item">
              <span class="status">Done</span>
              <span class="num">02</span>
            </button>
          </li>
          <li class="status-list bg-gray">
            <button type="button" class="status-item">
              <span class="status">Cancelled</span>
              <span class="num">01</span>
            </button>
          </li>
          <li class="status-list bg-gray">
            <button type="button" class="status-item">
              <span class="status">Closed</span>
              <span class="num">01</span>
            </button>
          </li>
          <li class="status-list bg-gray">
            <button type="button" class="status-item">
              <span class="status">Confirmed</span>
              <span class="num">01</span>
            </button>
          </li>
          <li class="status-list bg-bk">
            <button type="button" class="status-item">
              <span class="status">Approved</span>
              <span class="num">01</span>
            </button>
          </li>
        </ul>
      </div>
    </b-card>
    -->
    <!-- /Today Work -->
    <span v-if="!isCreatable" style="margin-left: 0.8em; font-size: 0.9rem; color: red;">
      *현재 참여 중인 프로젝트가 없습니다. 담당자에게 문의해 주세요
    </span>
    <!-- Card -->
    <b-card class="chatter-list">

      <!-- Card body -->
      <template #default>
        <div style="position:relative">

          <!-- Spinner -->
          <loading :active="loading" :is-full-page="false" />
          <!-- /Spinner -->

          <!-- Filter -->
          <chatter-filter @reload="reloadChatterList" @refresh="refreshChatterList" :isRefreshed="refresh"
            :isCreatable="isCreatable" />
          <!-- /Filter -->
          <b-col class="d-flex justify-content-between">
            <div class="filter-button-area">
              <span class="list-button-label" @click="clickHierarchyToggleHandler"
                :class="filter.retrieveType !== 'FILTER' ? 'disabled' : ''">
                <span style="margin-right: 0.3em;">Show Hierarchy</span>
                <div style="display: inline-block;"
                  :class="[filter.hierarchy == false ? 'toggle-switch' : 'toggle-switch on']"></div>
              </span>
              <div class="filter-refresh-button" @click="clickRefreshButtonHandler">
                <span class="list-button-label" style="margin-right: 0.3em;">Refresh</span>
                <RefreshIcon></RefreshIcon>
              </div>
            </div>
            <base-button v-if="notificationCount > 0 && filter.retrieveType == 'UPDATED'" size="sm"
              @click="removeNotifications">
              Mark as read
              <ChatterTooltip style="width: 20px; margin-left: 0.5rem">
                <!-- <template #header>
                  <span style="color: white">Mark as read</span>
                </template> -->
                <template #content>
                  모든 알림을 읽음 처리
                  <div style="color:red; font-size: 0.8rem;">단, Assignee로 등록된 MeMO는 제외</div>
                </template>
              </ChatterTooltip>

            </base-button>
          </b-col>

          <!-- Table -->
          <div class="custom-table-container">
            <table class="table table-hover custom-table">
              <colgroup>
                <col v-for="column in columns" :key="column.name" :width="column.width" />
              </colgroup>

              <thead>
                <tr class="text-center table-dark">
                  <th v-for="column in columns" :key="column.name" @click="sort(column)" class="chat-list-header">
                    {{ column.name | formatColumnName }}
                    <b-icon-triangle-fill v-if="column.sort === 'ASC'" font-scale="0.75" />
                    <b-icon-triangle-fill flip-v v-else-if="column.sort === 'DESC'" font-scale="0.75" />
                  </th>
                </tr>
              </thead>

              <tbody v-if="chats.length !== 0">
                <tr v-for="chat in chats" :key="chat.chatId" @click="showChatDetail(chat.chatId)"
                  style="cursor: pointer;" :style="rowColor(chat)"
                  :class="[substatus(chat), { 'unmatched': filter.hierarchy && !chat.matched }]">
                  <!-- Chat ID -->
                  <td class="text-center align-middle">
                    <b-badge class="btn updated" variant="danger" :disabled="true" v-if="chat.updated">Updated
                    </b-badge>
                    {{ chat.chatId }}
                  </td>
                  <!-- /Chat ID -->

                  <!-- Project -->
                  <td class="text-center align-middle">
                    {{ formatProject(chat.projectId) }}
                  </td>
                  <!-- /Project -->

                  <!-- Status -->
                  <td class="text-center align-middle">
                    <!-- 태그 별 클래스 추가 위한 함수 추가 / in-progress 이면서 due date 지났을 경우, 클래스 in-progress-red 추가  -->
                    <span v-if="chat.type == 'archive'" class="status-tag" :class="getStatusTagClass(chat.status)">{{
                      'Archive'
                      }}</span>
                    <span v-else class="status-tag" :class="getStatusTagClass(chat.status)">{{ chat.status |
                      formatStatus
                      }}</span>
                  </td>
                  <!-- /Status -->

                  <!-- Title -->
                  <td class="align-middle">
                    <div class="title-wrap">
                      <div class="title-container">

                        <!-- Parent chatter title -->
                        <b-form-row>
                          <b-collapse v-if="chat.subordinateTo" :id="'chatter-hierarchy' + chat.chatId"
                            class="chatter-hierarchy" v-model="chat.isExpanded">
                            {{ reformatMemoTitle(chat.subordinateTo) }}
                          </b-collapse>
                        </b-form-row>
                        <!-- /Parent chatter title -->

                        <b-form-row>
                          <b-col style="display: flex; align-items: center; position: relative; min-height: 2.4rem;">
                            <!-- Subordinate To icon: shows a popover when hovered -->
                            <button type="button" v-if="chat.subordinateTo != null && chat.isExpanded === false"
                              :id="'popover-subordinateTo' + chat.chatId + chat.subordinateTo.chatId"
                              class="btn-subordinate" @click.stop="toggleChatExpansion(chat)">
                              <span class="icon">
                                <SubordinateToIcon />
                              </span>
                              <b-popover :target="'popover-subordinateTo' + chat.chatId + chat.subordinateTo.chatId"
                                triggers="hover" placement="top">
                                <template #title>Superior To</template>
                                <b-form-row selectable @click="showChatDetail(chat.subordinateTo.chatId)"
                                  style="cursor:pointer;">
                                  {{ `[${chat.subordinateTo.chatId}]` }}
                                  <!-- Business Category -->
                                  <span>
                                    {{ reformatMemoTitle(chat.subordinateTo) }}
                                  </span>
                                </b-form-row>
                              </b-popover>
                            </button>
                            <!-- /Subordinate To icon: shows a popover when hovered -->

                            <!-- Current chatter title -->
                            <span v-if="chat.subordinateTo && chat.isExpanded === true" style="display: inline-block;"
                              class="icon-arrow-subordinate" @click.stop="toggleChatExpansion(chat)">
                              <SubordinateToArrowIcon />
                            </span>
                            <span class="title-text">
                              <span v-if="chat.changeSubordinate">
                                <span v-if="chat.depth > 0">
                                  {{ getDepth(chat.depth) }}
                                </span>
                                <!-- 계층을 추가했을 때 -->
                                <span v-if="chat.changeSubordinate === 'connect'">
                                  <img style="width:15px; height:15px; margin-right:0.2em;" :src="require('@/assets/images/link.png')" />
                                  <!-- <b-icon icon='plus' class="mr-1"></b-icon> -->
                                </span>

                                <!-- 계층을 삭제했을 때 -->
                                <span v-if="chat.changeSubordinate === 'disconnect'">
                                  <img style="width:15px; height:15px; margin-right:0.2em;" :src="require('@/assets/images/link.png')" />
                                </span>

                                <!-- 계층을 변경했을 때 -->
                                <span v-if="chat.changeSubordinate === 'change'">
                                  <img style="width:15px; height:15px; margin-right:0.2em;" :src="require('@/assets/images/link.png')" />
                                </span>
                              </span>
                              <span v-else>
                                <span v-if="chat.depth > 0">
                                  {{ getDepth(chat.depth) }}
                                  <b-icon icon='arrow-return-right' class="mr-1"></b-icon>
                                </span>
                              </span>
                              <span class="business-category-title">
                                {{ getBusinessCategory(chat) }}
                              </span>
                              {{ chat.title }}
                            </span>
                            <!-- /Current chatter title -->

                            <!-- Level -->
                            <span :style="{ color: getIconColor(chat.level, 'square') }">
                              <span v-if="chat.level !== ''" class="level-circle">●</span>
                            </span>
                            <!-- /Level -->

                            <!-- Superior To icon: shows a popover when hovered -->
                            <button type="button" v-if="chat.superiorTo.length > 0 && chat.isExpanded === false"
                              :id="'popover-superiorTo' + chat.chatId + chat.superiorTo.chatId" class="btn-superior"
                              @click.stop="toggleChatExpansion(chat)">
                              <SuperiorToIcon />
                              <b-popover :target="'popover-superiorTo' + chat.chatId + chat.superiorTo.chatId"
                                triggers="hover" placement="bottom">
                                <template #title>Subordinate To</template>
                                <b-form-row v-for="chat in chat.superiorTo" :key="chat.chatId" selectable
                                  @click="showChatDetail(chat.chatId)" style="cursor:pointer;">
                                  {{ `[${chat.chatId}]` }}
                                  <!-- Business Category -->
                                  <span>
                                    {{ reformatMemoTitle(chat) }}
                                  </span>
                                </b-form-row>
                              </b-popover>
                            </button>
                            <!-- /Superior To icon: shows a popover when hovered -->
                            <span @click.stop="toggleChatExpansion(chat)">
                              <SuperiorToArrowIcon v-if="chat.superiorTo.length > 0 && chat.isExpanded === true" />
                            </span>

                          </b-col>

                          <!-- Expansion button: shows all related chatters -->
                          <!-- <b-col cols="1"
                             v-if="chat.subordinateTo != null || chat.superiorTo.length > 0"
                             style="text-align: end; display: flex; align-items: center;">
                        <b-badge class="btn"
                                 variant="secondary"
                                 v-b-toggle="'chatter-hierarchy' + chat.chatId"
                                 @click.stop="chat.isExpanded = !chat.isExpanded">
                            <span style="font-weight:bold;">
                              {{ chat.isExpanded ? "-" : "+" }}
                            </span>
                        </b-badge>
                      </b-col> -->
                          <!-- Expansion button: shows all related chatters -->
                        </b-form-row>

                        <!-- Child chatters title -->
                        <b-form-row>
                          <b-col>
                            <b-collapse v-if="chat.superiorTo.length > 0 && chat.isExpanded === true"
                              v-model="chat.isExpanded" :id="'chatter-hierarchy' + chat.chatId">
                              <b-form-row v-for="child in chat.superiorTo" :key="child.chatId" selectable
                                @click="showChatDetail(child.chatId)"
                                style="cursor: pointer; align-items: center; flex-wrap: nowrap; padding-left: 50px;">
                                <!-- <span style="display: inline-block; transform: translateY(-4px); margin-left: 20px;">
                                <SuperiorToArrowIcon/>
                              </span> -->
                                <span class="chatter-hierarchy">{{ reformatMemoTitle(child) }}</span>
                              </b-form-row>
                            </b-collapse>
                          </b-col>
                        </b-form-row>
                        <!-- /Child chatters title -->

                      </div>
                    </div>
                  </td>
                  <!-- /Title -->

                  <!-- Priority -->
                  <td class="text-center" :style="{ color: getIconColor(chat.level, 'arrow') }">
                    {{ chat.priority | formatPriority }}
                  </td>
                  <!-- /Priority -->

                  <!-- Start date ~ Due date -->
                  <td class="text-center align-middle">
                    <span v-if="chat.startDate != ''" style="white-space: nowrap">{{ chat.startDate }}</span>
                    <span v-if="chat.startDate != '' || chat.dueDate != ''"> ~ </span>

                    <span v-if="chat.dueDate != ''" style="white-space: nowrap">{{ chat.dueDate }}</span>
                  </td>
                  <!-- /Start date ~ Due date -->

                  <!-- Assignee -->
                  <td class="text-center">
                    <div class="assignee-wrap">
                      <!-- 사용자 프로필 추가 -->
                      <span class="user-profile">
                        <img :src="userDetail(chat.assignee).profileImg" alt="user profile">
                        <!--
                        <img v-if="chat.userProfileImgPath && chat.userProfileImgPath !== ''"
                            :src="'data:image/' + chat.userProfileImgName.substr(chat.userProfileImgName.lastIndexOf('.')) + ';base64,' + chat.userProfileImgPath"
                            alt="user profile">
                        <img v-else
                            src="../../assets/images/icon_user.png"
                            alt="user profile">
                        -->
                        <!--
                        <img src="../../assets/images/icon_user.png" alt="user profile">
                        -->
                      </span>
                      <!-- 금일 휴가인 assignee는 profile img 우측 상단에 'zzz' img 표시-->
                      <img class="user-today-off-img" src="../../../assets/images/icon_today_off.png"
                        v-if="isTodayOffUser(chat.assignee)" alt="today off">
                      <span class="assignee-name" v-if="chat.userName" v-b-tooltip.hover :title="chat.assignee">
                        <span class="unread-label" v-if="chat.unread">
                          <I>UNREAD</I></span>
                        {{ chat.userName }}</span>
                      <span class="assignee-name" v-else>{{ chat.assignee }}</span>
                    </div>
                  </td>
                  <!-- /Assignee -->
                </tr>
              </tbody>

              <tbody v-else>
                <tr>
                  <td colspan="11" style="text-align:center">결과가 없습니다.
                  </td>
                </tr>
              </tbody>

            </table>
          </div>
          <!-- Table -->

          <!-- See More button -->
          <div class="btn-more-area">
            <button class="btn btn-view-more" @click="seeMore"
              :disabled="chats.length >= total || total < pageLimit + 1">
              <span class="icon"><see-more-icon /></span>
              <span style="font-weight: 700;">See More&nbsp;</span>
              <span>({{ chats.length }}/{{ total }})</span>
            </button>
          </div>
          <!-- See More button -->
        </div>
      </template>
      <!-- Card body -->
    </b-card>
  </div>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import ChatterStatusTable from "@/components/chatter/chat/ChatterStatusTable.vue";
import ChatterFilter from '@/components/chatter/chat/ChatterFilter.vue';
import ProjectFilter from '../wbs/ProjectFilter.vue';

import RefreshIcon from "@/components/chatter/icons/RefreshIcon.vue";
import SubordinateToArrowIcon from "@/components/chatter/icons/SubordinateToArrowIcon.vue";
import SuperiorToArrowIcon from "@/components/chatter/icons/SuperiorToArrowIcon.vue";
import SubordinateToIcon from "@/components/chatter/icons/SubordinateToIcon.vue";
import SuperiorToIcon from "@/components/chatter/icons/SuperiorToIcon.vue";
import SeeMoreIcon from "@/components/chatter/icons/SeeMoreIcon.vue";
import BaseButton from '../requirement/BaseButton.vue';
import ChatterTooltip from './ChatterTooltip.vue';

export default {
  name: "ChatterList",
  components: {
    Loading,
    ChatterFilter,
    ChatterStatusTable,
    ProjectFilter,
    RefreshIcon,
    SubordinateToArrowIcon,
    SuperiorToArrowIcon,
    SuperiorToIcon,
    SubordinateToIcon,
    SeeMoreIcon,
    BaseButton,
    ChatterTooltip
  },
  computed: {
    chats() {
      var chats = this.$store.getters['chatter/chats'];
      //status bar 활성화된 경우(pageLimit 만큼 chat load)
      if (this.occupied) {
        return chats.slice(0, this.pageLimit * this.filter.page);
      }
      return chats;
    },
    notificationCount() {
      return this.$store.getters['chatter/getNotificationCount'];
    },
    total() {
      return this.$store.getters['chatter/total'];
    },
    filter() {
      return this.$store.getters['chatter/filter'];
    },
    options() {
      return this.$store.getters['chatter/options'];
    },
    occupied() {
      return this.$store.getters['chatter/occupied'];
    },
    filterOccupied() {
      return this.$store.getters['chatter/filterOccupied'];
    },
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
    userId() {
      return this.currentUser.caller;
    },
    updated() {
      return this.$store.getters['chatter/getUpdated'];
    },
    statusDashboardFilter() {
      return this.$store.getters['chatter/statusDashboardFilter'];
    },
    assigneeOptions() {
      return this.$store.getters['chatter/assigneeOptions'];
    },
    searchOptionsLabel() {
      return this.$store.getters['chatter/searchOptionsLabel'];
    },
    todayOffUserIdList() {
      return this.$store.getters['chatter/todayOffUserIdList'];
    },
    refresh() {
      return this.$store.getters['chatter/chatterListRefresh'];
    },
    disabledShowHierarchyButton() {
      return this.filter.retrieveType === 'RECENT';
    },
    isCreatable() {
      let projectOptions = this.$store.getters['chatter/options']['projectOptions'];
      if (projectOptions.length <= 0) {
        return false;
      }

      //toggle 여부에 따라 보이는 project 다르게
      // 로그인한 사용자가 참여하고 있는 Open상태의 프로젝트의 개수가 하나라면 해당 프로젝트를 기본 프로젝트로 설정
      const openProjectOptions = projectOptions.filter(project => project.status == "OPEN");
      return openProjectOptions.length != 0;
    },
  },
  watch: {
    /*
    updated(value) { // computed에 지정한 updated 속성이 바뀌면 콜백 실행
      console.log("updated")
      if (value === 'Y') {
        this.reloadChatterList();
      }
    },
    */
  },
  data() {
    return {
      pageLoaded: false,
      wbsProject: '',
      loading: false,
      columns: [
        { name: 'id', colName: 'chat_id', sort: '', width: "6.811%" },
        // { name: 'level', colName: "level", sort: '', width: "3%" },
        { name: 'project', colName: 'project_id', sort: '', width: "13.043%" },
        { name: 'status', colName: 'status', sort: '', width: "8.695%" },
        { name: 'title', colName: 'title', sort: '', width: "60.434%" },
        { name: 'priority', colName: 'priority', sort: '', width: "8.695%" },
        { name: 'start ~ Due Date', colName: 'start_date', sort: '', width: "15.362%" },
        // { name: 'dueDate', colName: 'due_date', sort: '', width: "10%" },
        { name: 'assignee', colName: 'assignee', sort: '', width: "10.144%" },
      ],
      chattererOptions: [],
      sortedColumns: [],
      pageLimit: 10,
      // refresh: false,
    }
  },
  async created() {
    try {
      await this.$store.dispatch('chatter/retrieveAllProjectInfo');

      /* searchOptionsLabel(검색조건) 생성 로직: 검색 조건 걸고-> Detail 조회-> Close 후에도 라벨이 남아있기 위함*/
      // StatusBar 또는 Filter Label 만드는 함수 호출
      /* searchOptionsLabel(검색조건) 생성 로직 */

      // 24-08-23 로그인 사용자 기본 필터 해제
      // if (this.filter.assignee == '') {
      //   this.filter.assignee = this.userId;
      // }

      if (!this.chats.length > 0) {

        this.retrieveChatterList();
      }

      this.pageLoaded = true;
    } catch(e) {
      console.log(e);
      this.pageLoaded = true;
    }
  },
  methods: {
    async retrieveChatterList() {
      // If Chatter Status Table has already occupied the list, return
      // For details, refer to Chatter Vuex (chatter.module.js)
      try {
        this.loading = true;
        // Fetch chats
        let response = await axios.post('/chatter/retrieveChatterList',
          this.filter,
          { headers: { Authorization: accessToken() } }
        );

        const status = response.data.status;
        if (status === "200") {
          // Commit the newly fetched chatters to Vuex
          const body = response.data.body;
          body.list.forEach(item => item.isExpanded = false);
          this.$store.commit('chatter/setChats', body.list);
          this.$store.commit('chatter/setTotal', body.total);

        } else {
          this.$bvToast.toast(response.data.message,
            {
              title: `Notification`,
              toaster: "b-toaster-bottom-center",
              solid: true,
              appendToast: false,
              autoHideDelay: 500,
              variant: "danger"
            });
        }

        // Set the total number of chatters in Vuex

        //refresh 값 초기화(자식(=ChatterFilter.vue)에게 보내고 나면 초기화)=> Search Detail 창 닫힘, 작성중인 query 초기화
        // this.refresh = false;

      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    refreshChatterList() {
      this.$store.commit('chatter/setOccupied', false);
      this.$store.commit('chatter/setFilterOccupied', false);
      this.$store.commit('chatter/resetChats');
      this.$store.commit('chatter/setTotal', 0);
      this.$store.commit('chatter/resetFilter');
      this.$store.commit('chatter/chatterListRefresh');
      // this.refresh = true;
      //search Detail 창 닫기
      this.$store.commit('chatter/setToggleFilterSearchDetail', false);
      //검색 조건 내용 초기화
      this.$store.commit('chatter/setSearchOptionsLabel', '');
      this.retrieveChatterList();
      //statusbar 정보 초기화
      this.$store.commit('chatter/resetStatusDashboardFilter');
    },
    reloadChatterList() {
      this.$store.commit('chatter/setRetrieveType', "FILTER");
      this.resetPaigination();
      this.retrieveChatterList();
    },
    resetPaigination() {
      this.$store.commit('chatter/resetChats');
      this.$store.commit('chatter/setTotal', 0);
      this.$store.commit('chatter/setPage', 1);
    },
    seeMore() {
      // console.log('호출');
      // //status bar 활성화된 상태
      // if (this.occupied) {
      //   console.log('알림 호출');
      //   this.$store.commit('chatter/incrementPage');
      //   //chat list 추가
      //   this.chats;
      // }
      // //filter 활성화된 상태
      // else {
      //   this.$store.commit('chatter/incrementPage');
      //   this.retrieveChatterList();
      // }

      this.$store.commit('chatter/incrementPage');
      this.retrieveChatterList();
    },
    async removeNotifications() {
      try {
        // 삭제 API 호출
        const removeNotificationRes = await axios.post('/chatter/removeAllNotifications', {},
          { headers: { Authorization: accessToken() } }
        );

        if (removeNotificationRes.data.status !== "200") {
          // 알림 메세지 출력
          return;
        }

        // 남은 Notifications 가져온 후 탑바의 Notification 최신화
        await this.$store.dispatch('chatter/getNotifications');

        // 남은 Notifications가 0개가 아니면 목록 다시 조회
        console.log(this.notificationCount);
        if (this.notificationCount > 0) {
          this.$store.commit('chatter/setRetrieveType', "UPDATED");
          this.resetPaigination();
          this.retrieveChatterList();
        } else {

          // 0개면 빈 배열로 초기화
          this.$store.commit('chatter/setChats', 0);
          this.$store.commit('chatter/setTotal', []);
        }
      } catch (e) {
        console.log(e);
      }

    },
    sort(column) {
      // Switch sorting order
      column.sort = ({
        '': 'ASC',
        ASC: 'DESC',
        DESC: ''
      })[column.sort];

      // Commit sorting orders
      this.$store.commit('chatter/setSort', this.columns)

      // Reload chatter list
      this.reloadChatterList();
    },
    substatus(chat) {
      let inactive = ['DONE', 'CLOSED', 'CANCELLED']
      if (inactive.includes(chat.status) || chat.dueDate === '') {
        return 'unknown';
      } else if (chat.dueDate === this.today) {
        return 'dueOnToday';
      } else if (chat.dueDate < this.today) {
        return 'overdue';
      }
    },
    rowColor(chat) {
      return {
        color: ({
          dueOnToday: 'GoldenRed',
          overdue: 'Red',
          unknown: 'Black'
        })[this.substatus(chat)]
      }
    },
    getIconColor(level, type) {
      switch (type) {
        case 'square':
          switch (level) {
            case '3':
              return '#FF0000';
            case '2':
              return '#FF9900';
            case '1':
              return '#FFE600';
            case '0':
              return '#C4C4CD';
            default:
              return '';
          }
      }
    },
    showChatDetail(chatId) {
      this.$router.push({ name: "chatUpdate", params: { id: chatId } });
    },
    formatProject(value) {
      return this.options.projectOptions.filter(prj => prj.projectId === value)[0].name;
    },
    getStatusTagClass(status) {
      return status.replace('_', '-').toLowerCase();
    },
    // "" -> "All" 치환
    isEmpty(str) {
      return str === undefined || str === '' || str === null;
    },
    //searchOptionsLabel 생성
    /** 24-02-23 yhkim@hiaas.co.kr
     *  label 생성 로직 변경
     * @param {project, status, assignee} options 
     */
    getSearchOptionsLabel(project, status, subStatus, assignee) {
      // const keys = Object.keys(options);

      if (this.isEmpty(project)) {
        project = "All Projects";
      }

      if (this.isEmpty(status)) {
        status = "All Status";
      }

      if (!this.isEmpty(subStatus)) {
        status += " > " + subStatus;
      }

      if (this.isEmpty(assignee)) {
        assignee = "All Assignee";
      }

      return `${project} > ${status} > ${assignee}`;

    },
    clickSubStatusBadgeHandler(statusPair) {
      const status = statusPair.status;
      const subStatus = statusPair.subStatus;

      this.filter.status = status;
      this.filter.subStatus = subStatus;

      this.reloadChatterList();
    },

    // expansion button 클릭 시 expansion 각각 작동하도록 함
    toggleChatExpansion(chat) {
      chat.isExpanded = !chat.isExpanded;
    },

    // current MeMO title 제외 다른 부분에서 사용
    reformatMemoTitle(chat) {
      return (chat.businessCategory != null && chat.businessCategory != '') ? '[' + chat.businessCategory + '] ' + chat.title : chat.title;
    },
    // current MeMO title에서는 business category를 작게 보여줘야 하므로 reformatMemoTitle대신 이 메서드 사용
    getBusinessCategory(chat) {
      return (chat.businessCategory != null && chat.businessCategory != '') ? '[' + chat.businessCategory + '] ' : '';
    },
    getDepth(depthLevel) {
      let depth = ''
      for (let i = 0; i < depthLevel; i++) {
        depth += '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0';
      }
      return depth;
    },
    //assignee가 금일 휴가인지 확인
    isTodayOffUser(userId) {
      return this.todayOffUserIdList.includes(userId);
    },
    userDetail(userId) {
      return this.$store.getters['chatter/getUserByUserId'](userId);
    },

    clickHierarchyToggleHandler() {
      this.filter.hierarchy = !this.filter.hierarchy;
      this.$store.commit('chatter/resetChats');
      this.$store.commit('chatter/setTotal', 0);
      this.$store.commit('chatter/setPage', 1);
      this.retrieveChatterList();
    },
    clickRefreshButtonHandler() {
      this.refreshChatterList();
    }
  },
  filters: {
    formatStatus(strStatus) {
      let arrStrStatus = strStatus.split("_");
      let result = '';
      for (let i in arrStrStatus) {
        let str = arrStrStatus[i]
        result = result + " " + str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      }
      return result
    },
    formatColumnName(name) {
      // 첫 글자를 대문자로 변경하고 중간에 대문자가 있는 경우 띄어쓰기 추가
      if (name.toUpperCase() === "ID") {
        // Exception. Id의 경우 모두 대문자로 변환하여 사용 - 20230614 박선익
        return name.toUpperCase()
      }
      return name.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
        return str.toUpperCase();
      });
    },
    formatPriority(priority) {
      switch (priority) {
        case '2': // High
          // return '↑';
          return 'High';
        case '1': // Medium
          // return '-';
          return 'Medium';
        case '0': // Low
          // return '↓';
          return 'Low';
        case '-':
          return '';
        default:
          return '';
      }
    },
  },
}
</script>
<style>
td {
  vertical-align: middle;
}

.unread-label {
  position: absolute;
  top: 30%;
  left: 40%;
  transform: translate(-50%, -50%) rotate(-15deg);
  color: red;
  opacity: 0.9;
  font-size: 0.4em;
}

.down-arrow-icon {
  transform: translate(-50%, -50%) rotate(180deg);
  margin-left: 1em;
}

.chat-list-header {
  user-select: none;
  /* 드래그 불가능 */
  cursor: pointer;
  /* 포커스 시 커서를 손가락 모양으로 설정 */
}

.tooltip .tooltip-inner {
  max-width: 1000px !important;
  white-space: pre-wrap !important;
  text-align: start;
}

.popover {
  max-width: 1000px !important;
}

#export .modal-dialog {
  padding: 0;
}

#export .modal-body {
  padding: 0;
}

/* excel export 팝업 */
.popup-export.modal.show .modal-dialog {
  margin: 0 auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.popup-export .modal-content {
  border-radius: 20px;
}

.popup-export .modal-header {
  align-items: center;
  padding: 2.083vw 2.666rem 1.041vw;
  border-radius: 20px 20px 0 0;
  border-bottom: 0px;
}

.popup-export .modal-title {
  margin-bottom: 0 !important;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
}

.popup-export .modal-header .close {
  width: 30px;
  height: 30px;
  margin: 0;
  font-size: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M22.5 22.5L7.5 7.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><path d="M22.5 7.5L7.5 22.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

.popup-export#export .modal-body {
  padding: 1.041vw 2.666rem;
}

.popup-export label {
  padding-left: 0.4rem;
  margin-bottom: 0.53rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

.popup-export .modal-body .custom-select {
  -o-appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

.popup-export .btn-wrap {
  display: flex;
  align-items: center;
  gap: 0 0.666rem;
  padding: 2.604vw 0 1.562vw;
}

.popup-export .btn-wrap .btn {
  border-color: transparent;
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.popup-export .btn-wrap .btn-primary.small {
  width: 148px;
  height: 40px;
  background-color: #2E2E38;
  color: #FFE600;
}

.popup-export .btn-wrap .btn-primary:hover {
  color: #FFE600;
  background-color: #0D0D17;
  border-color: transparent;
}

.popup-export .btn-wrap .btn-primary.disabled,
.popup-export .btn-wrap .btn-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.popup-export .btn-wrap .btn-secondary.small {
  width: 148px;
  height: 40px;
  border-radius: 10px;
  background: #747480;
  color: #fff;
}

.popup-export .btn-wrap .btn-secondary:hover {
  background-color: #565662;
}

.popup-export .btn-wrap .btn-secondary.disabled,
.popup-export .btn-wrap .btn-secondary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}
</style>

<style scoped>
/* import font */
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

.filter-button-area {
  margin-top: 0.5em;
  display: flex;
  justify-items: center;
  height: 100%;
}

.filter-refresh-button {
  padding: 0;
  display: flex;
  align-items: center;
  margin-left: 1em;
  border: none;
  background-color: transparent;
}

.filter-refresh-button:hover {
  cursor: pointer;
}

.list-button-label {
  font-size: 0.9rem;
  font-weight: bold;
  display: flex;
  /* flex-direction: column; */
  justify-content: center;
  align-items: end;
  text-align: center;
}

.list-button-label:hover {
  cursor: pointer;
}

.list-button-label.disabled {
  pointer-events: none;
  opacity: 0.5;
}

/* button */
.btn {
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.btn:focus {
  box-shadow: none;
}

.btn-primary {
  width: 280px;
  height: 60px;
  background-color: #2E2E38;
  color: #FFE600;
  border-color: transparent;
}

.btn-primary:hover {
  color: #FFE600;
  background-color: #0D0D17;
  border-color: transparent;
}

.btn-primary.disabled,
.btn-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.btn-primary.small {
  width: 148px;
  height: 40px;
}

.btn-export {
  width: 100px;
  height: 40px;
  background-color: #168D4C;
  color: #fff;
  border-color: transparent;
}

.btn-export:hover {
  background-color: #006F2E;
  border-color: transparent;
}

.btn-export.disabled,
.btn-export:disabled {
  color: #62796D;
  background-color: #759483;
}

.btn.btn-line {
  position: relative;
  width: 135px;
  height: 60px;
  border: 1px solid #C4C4CD;
  background-color: transparent;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  text-align: inherit;
}

.btn.btn-line:hover {
  color: #2E2E38;
  border: 1px solid #2E2E38;
  background-color: transparent;
}

.btn.btn-line.disabled,
.btn.btn-line:disabled {
  border: 1px solid #DDDDE3;
  background-color: transparent;
}

.btn.btn-line.small {
  height: 40px;
  text-align: center;
}

.btn-refresh {
  height: auto;
  padding: 0;
}

/* 공통요소 */
.select-custom-scrollbar::-webkit-scrollbar {
  width: 12px;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

.select-custom-scrollbar::-webkit-scrollbar-track {
  width: 6px;
  background-color: #E7E7EE;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

.select-custom-scrollbar::-webkit-scrollbar-thumb {
  width: 100%;
  background-color: #C4C4CD;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 6px solid transparent;
  background-clip: padding-box;
}

/* card 영역 */
.card {
  margin-bottom: 2rem;
  border-radius: 30px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  font-family: 'NanumGothic';
}

.card>.card-body {
  padding-top: max(2rem, 1.5625vw);
  padding-left: 2.0833vw;
  padding-right: 2.0833vw;
  /* padding-bottom: max(2.666rem, 2.0833vw); */
}

/* today work 영역 */
.card.today-work-wrap .card-body {
  padding-bottom: max(2rem, 1.5625vw);
}

.work-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0 1.333rem;
}

.work-wrap .work-progress .title-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.533rem;
}

.work-wrap .work-progress .title-wrap .title {
  font-size: 18px;
  font-weight: 700;
}

.work-wrap .work-progress .title-wrap .rate {
  font-size: 14px;
  font-weight: 400;
  color: #06F;
}

.work-wrap .work-progress .title-wrap .rate span:first-child {
  font-weight: 700;
}

.work-wrap .work-progress .progress-bar {
  width: 17.3333rem;
  height: 26px;
  border-radius: 8px;
  border: 1px solid rgba(0, 102, 255, 0.10);
  background-color: #D8E7FF;
}

.work-wrap .work-progress .progress-bar .bar {
  height: 100%;
  background-color: #06F;
}

.work-wrap .work-progress {
  flex-grow: 0;
  flex-shrink: 1;
  margin-right: 60px;
}

.work-wrap .status-list-wrap {
  flex-shrink: 1;
  flex-grow: 1;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(9.333rem, auto));
  gap: 0.4rem;
  padding: 0;
  margin: 0;
  list-style: none;
}

.work-wrap .status-list-wrap .status-list {
  /* min-width: 140px; */
  height: 40px;
}

.work-wrap .status-list-wrap .status-list .status-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0 10px;
  min-width: 100%;
  height: 100%;
  padding: 0 0.466rem 0 0.8rem;
  border-radius: 34px;
  border: 1px solid #DDDDE3;
  background-color: #fff;
  font-size: 14px;
  color: #2E2E38;
}

.work-wrap .status-list-wrap .status-list:hover .status-item {
  border: 1px solid #2E2E38;
}

.work-wrap .status-list-wrap .status-list .status-item span {
  display: inline-block;
}

.work-wrap .status-list-wrap .status-list.bg-gray .status-item {
  border: 1px solid transparent;
  background-color: #E7E7EE;
}

.work-wrap .status-list-wrap .status-list.bg-gray:hover .status-item {
  background-color: #D4D4DC;
}

.work-wrap .status-list-wrap .status-list.bg-bk .status-item {
  border: 1px solid transparent;
  background-color: #40404B;
  color: #fff;
}

.work-wrap .status-list-wrap .status-list.bg-bk:hover .status-item {
  background-color: #1B1B1B;
}

.work-wrap .status-list-wrap .status-item .status {
  font-weight: 500;
  line-height: 150%;
}

.work-wrap .status-list-wrap .status-item .num {
  height: 26px;
  padding: 0 0.5rem;
  border-radius: 30px;
  background-color: #fff;
  color: #2E2E38;
  text-align: center;
  line-height: 26px;
  font-weight: 700;
  font-size: 14px;
}

.work-wrap .status-list-wrap .status-list.bg-bk .status-item .num {
  background-color: transparent;
  color: #fff;
}

/* chatter list 영역 */
.card.chatter-list {
  margin-bottom: 2rem;
  border-radius: 30px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
}

.card.chatter-list .unmatched {
  opacity: 0.3;
}

/* my chatter list table 영역 */
.custom-table-container {
  margin-top: 1rem;
  padding: 0.666rem;
  border-radius: 20px;
  background-color: #F6F6FA;
}

.table.custom-table {
  margin-bottom: 0;
}

.table.custom-table tr {
  color: #2E2E38;
  background-color: #FFF;
}

.table.custom-table tr:hover {
  background-color: #FAFAFA;
}

.table.custom-table thead th,
.table-bordered.custom-table th {
  height: 70px;
  padding-top: calc(0.75rem - 0.666rem);
  background-color: #F6F6FA;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #C4C4CD;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
  vertical-align: middle;
  white-space: nowrap;
}

.table.custom-table td {
  min-height: 80px;
  padding: 1.333rem 0.666vw;
  border-top: 1px solid #E7E7EE;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  vertical-align: middle;
}

.table.custom-table td .title-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table.custom-table td .title-wrap .title-container {
  flex-grow: 1;
}

.table.custom-table td .title-wrap .title-text {
  padding-left: 2.067rem;
  font-weight: 700 !important;
}

.table.custom-table td .title-wrap .chatter-hierarchy {
  display: flex;
  align-items: center;
  gap: 0 0.533rem;
  padding-left: 0.533rem;
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.btn-subordinate {
  border: none;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  display: inline-block;
  width: 36px;
  height: 36px;
  background-color: transparent;
  padding: 0;
}

.icon-arrow-subordinate {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 36px;
  height: 36px;
  background-color: transparent;
  padding: 0;
}

.btn-superior {
  display: inline-block;
  width: 36px;
  height: 36px;
  padding: 0;
  border: none;
  background-color: transparent;
}

.table.custom-table tr:last-child td:first-child {
  border-radius: 0 0 0 10px;
}

.table.custom-table tr:last-child td:last-child {
  border-radius: 0 0 10px 0;
}

.table.custom-table .status-tag {
  display: inline-block;
  max-width: 100px;
  width: 100%;
  height: 29px;
  padding: 4px 6px;
  border-radius: 38px;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  white-space: nowrap
}

.table.custom-table .status-tag.in-progress {
  background-color: #F5ECD6;
  color: #FF5C00;
}

.table.custom-table .overdue .status-tag.in-progress {
  background-color: #F5D6D6;
  color: #F00;
}

.table.custom-table .status-tag.to-do {
  background-color: #F6F6FA;
  color: #2E2E38;
}

.table.custom-table .status-tag.done {
  background-color: #CFDDFF;
  color: #1755CC;
}

.table.custom-table .status-tag.closed {
  background-color: #D7F5D6;
  color: #168D4C;
}

.table.custom-table .status-tag.cancelled {
  background-color: #E4E4EA;
  color: rgba(116, 116, 128, 0.70);
}

.btn.updated {
  padding: 0;
  background-color: transparent;
  border-radius: 0;
  color: #1755CC;
  font-size: 12px;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
  opacity: 1;
}

.level-circle {
  display: inline-block;
  font-size: 6px;
  margin-left: 0.533rem;
  transform: translateY(-1.5px);
}

.unread-label {
  position: relative;
  top: unset;
  left: unset;
  transform: none;
  color: #F00;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;
  opacity: 1;
}

.assignee-wrap {
  display: flex;
  align-items: center;
  gap: 0 0.729vw;
  width: 100%;
  white-space: nowrap;
}

.assignee-wrap .user-profile {
  position: relative;
  flex-grow: 1;
  flex-shrink: 0;
  display: inline-block;
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 50%;
}

.assignee-wrap .user-profile img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  object-fit: cover;
}

.assignee-wrap .user-today-off-img {
  position: absolute;
  width: 18px;
  height: 15px;
  transform: translate(165%, -120%);
}

.assignee-wrap .assignee-name {
  width: calc(100% - 40px - 0.729vw);
  max-width: 98px;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
}

.assignee-wrap .assignee-day-off {
  font-size: 10px;
}

.btn-more-area {
  display: flex;
  justify-content: center;
  margin-top: 2.666rem;
}

.btn-more-area .btn-view-more {
  display: inline-block;
  width: auto;
  height: auto;
  margin: 0;
  padding: 1.3rem 3.3rem 1.3rem 3.033rem;
  border-radius: 60px;
  background-color: #E7E7EE;
}

.btn-more-area .btn-view-more .icon {
  margin-top: -3px;
  margin-right: 0.533rem;
}

.btn-more-area .btn-view-more span {
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  line-height: 150%;
}

.btn-more-area .btn-view-more:hover {
  background-color: #C4C4CD;
}

/* .btn-reset-img{
  width:25px;
  height:27px;
  margin: 0 10px 0 10px;

}
.btn-recent-img{
  width:30px;
  height:30px;
} */
.refresh-button {
  display: flex;
  align-items: center;
  gap: 0 12px;
  padding: 8px 12px 8px 16px;
  border-radius: 40px;
  border: none;
  background-color: #2E2E38;
  color: #FFF;
  font-family: 'NanumGothic';
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
}

.refresh-button .icon {
  display: block;
  width: 18px;
  height: 18px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M13.5 13.5L4.5 4.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.5 4.5L4.5 13.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-repeat: no-repeat;
}

.business-category-title {
  font-size: 8pt;
}
</style>